import { Link } from 'react-router-dom'

function SectionContent({ section }) {
  return (
    <div className="space-y-3">
      {section.paragraphs?.map((paragraph, index) => (
        <p key={index} className="text-sm leading-7 text-ink/80">
          {paragraph}
        </p>
      ))}

      {section.bullets?.length ? (
        <ul className="ml-5 list-disc space-y-2 text-sm leading-7 text-ink/80">
          {section.bullets.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      ) : null}

      {section.note ? (
        <p className="rounded-xl border border-cyan-500/20 bg-cyan-500/10 px-4 py-3 text-sm leading-7 text-cyan-100">
          {section.note}
        </p>
      ) : null}
    </div>
  )
}

export default function LegalDocumentPage({
  title,
  subtitle,
  lastUpdated,
  intro,
  sections,
  contactEmail = 'contact@usts.ai',
  contactLabel = 'Contact',
  contactDescription,
}) {
  return (
    <>
      <main className="min-h-screen bg-panel text-ink">
        <header className="sticky top-0 z-20 border-b border-ink/10 bg-panel/90 backdrop-blur">
          <div className="mx-auto flex max-w-5xl items-center justify-between px-4 py-4 sm:px-6 lg:px-8">
            <Link to="/" className="flex items-center gap-3 text-ink">
              <img src="/brand/icon-192.png" alt="Jean Louis" className="h-8 w-8 rounded-lg object-cover" />
              <span className="text-sm font-semibold tracking-wide">Jean Louis</span>
            </Link>
            <div className="flex items-center gap-3 text-sm">
              <Link to="/login" className="text-ink/80 transition hover:text-ink">
                Connexion
              </Link>
              <Link
                to="/"
                className="rounded-full border border-ink/10 px-4 py-2 font-medium text-ink transition hover:border-cyan-400/40 hover:bg-ink/5"
              >
                Accueil
              </Link>
            </div>
          </div>
        </header>

        <section className="mx-auto max-w-5xl px-4 pb-20 pt-28 sm:px-6 lg:px-8">
          <div className="rounded-[14px] border border-ink/10 bg-ink/5 p-6 shadow-2xl shadow-cyan-500/5 backdrop-blur md:p-10">
            <div className="space-y-4 border-b border-ink/10 pb-8">
              <p className="text-xs font-semibold uppercase tracking-[0.35em] text-cyan-300">
                Documents légaux
              </p>
              <div className="space-y-2">
                <h1 className="text-3xl font-bold tracking-tight text-ink sm:text-4xl">{title}</h1>
                {subtitle ? <p className="text-sm text-foreground-secondary">{subtitle}</p> : null}
                {lastUpdated ? (
                  <p className="text-xs uppercase tracking-[0.25em] text-foreground-muted">
                    Dernière mise à jour : {lastUpdated}
                  </p>
                ) : null}
              </div>
              {intro ? <p className="max-w-3xl text-sm leading-7 text-ink/80">{intro}</p> : null}
            </div>

            <div className="mt-10 space-y-8">
              {sections.map((section) => (
                <article key={section.title} className="rounded-2xl border border-ink/10 bg-canvas/50 p-5 md:p-6">
                  <h2 className="mb-4 text-xl font-semibold text-ink">{section.title}</h2>
                  <SectionContent section={section} />
                </article>
              ))}
            </div>

            <div className="mt-10 grid gap-4 rounded-2xl border border-cyan-500/20 bg-cyan-500/10 p-5 md:grid-cols-[1fr_auto] md:items-center md:p-6">
              <div>
                <h2 className="text-lg font-semibold text-ink">{contactLabel}</h2>
                <p className="mt-2 text-sm leading-7 text-ink/80">
                  {contactDescription || 'Pour toute question liée à ce document, vous pouvez nous contacter à l’adresse ci-dessous.'}
                </p>
                <a
                  href={`mailto:${contactEmail}`}
                  className="mt-3 inline-flex text-sm font-medium text-cyan-300 transition hover:text-cyan-200"
                >
                  {contactEmail}
                </a>
              </div>
              <div className="flex flex-col gap-3 sm:flex-row md:flex-col lg:flex-row">
                <Link
                  to="/login"
                  className="inline-flex items-center justify-center rounded-full border border-ink/15 px-5 py-3 text-sm font-medium text-ink transition hover:border-cyan-400/40 hover:bg-ink/5"
                >
                  Se connecter
                </Link>
                <Link
                  to="/"
                  className="inline-flex items-center justify-center rounded-full bg-cyan-400 px-5 py-3 text-sm font-semibold text-slate-950 transition hover:bg-cyan-300"
                >
                  Retour à l’accueil
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  )
}
